export enum Color {
    main = "black",
    auxiliary = "#e7bd42",
    tertiary = "#0099cc",
    quaternary = "#e9e9e9",
    light = "white",
    pageBgColor = "white"//"whitesmoke" <-determina anche il bordo dei breadcrumbs
}
